var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M23.178 10.75a2.73 2.73 0 0 1 .645 2.921l-1.445 3.903a3.13 3.13 0 0 1-2.271 2.034 2.99 2.99 0 0 1-2.898-1.033L8.577 8.253a.19.19 0 0 0-.322.055L5.452 15.89a.191.191 0 0 0 .25.246L9.14 14.73a1.515 1.515 0 0 1 2.017.946 1.58 1.58 0 0 1-.909 1.929l-4.493 1.82a2.69 2.69 0 0 1-2.927-.533 2.7 2.7 0 0 1-.653-2.906l3.312-8.953a3.105 3.105 0 0 1 5.306-.91l4.943 5.914 4.543-1.856a2.65 2.65 0 0 1 2.898.569zm-2.335 2.91a.2.2 0 0 0-.05-.22.23.23 0 0 0-.233-.044L17.714 14.5l1.709 1.954a.22.22 0 0 0 .201.066.21.21 0 0 0 .164-.13z"
  })));
});
const SvgAirwallexShortLogoIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirwallexShortLogoIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMy4xNzggMTAuNzVhMi43MzIgMi43MzIgMCAwIDEgLjY0NSAyLjkyMWwtMS40NDUgMy45MDNhMy4xMzEgMy4xMzEgMCAwIDEtMi4yNzEgMi4wMzQgMi45ODggMi45ODggMCAwIDEtMi44OTgtMS4wMzNMOC41NzcgOC4yNTNhLjE5LjE5IDAgMCAwLS4zMjIuMDU1TDUuNDUyIDE1Ljg5YS4xOTEuMTkxIDAgMCAwIC4yNS4yNDZMOS4xNCAxNC43M2ExLjUxNSAxLjUxNSAwIDAgMSAyLjAxNy45NDYgMS41OCAxLjU4IDAgMCAxLS45MDkgMS45MjlsLTQuNDkzIDEuODJhMi42OTEgMi42OTEgMCAwIDEtMi45MjctLjUzMyAyLjcgMi43IDAgMCAxLS42NTMtMi45MDZsMy4zMTItOC45NTNhMy4xMDUgMy4xMDUgMCAwIDEgNS4zMDYtLjkxbDQuOTQzIDUuOTE0IDQuNTQzLTEuODU2YTIuNjUgMi42NSAwIDAgMSAyLjg5OC41Njl6bS0yLjMzNSAyLjkxYS4xOTguMTk4IDAgMCAwLS4wNS0uMjIuMjI1LjIyNSAwIDAgMC0uMjMzLS4wNDRMMTcuNzE0IDE0LjVsMS43MDkgMS45NTRjLjA1LjA1NC4xMjYuMDguMjAxLjA2NmEuMjE0LjIxNCAwIDAgMCAuMTY0LS4xM2wxLjA1NS0yLjczeiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";